import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Fullscreen = forwardRef<SVGSVGElement, SvgIconProps>(function Fullscreen(
  { fill = '#918D8D', ...props },
  ref,
) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path
        clipRule="evenodd"
        d="M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z"
        fill={fill}
        fillRule="evenodd"
      />
    </SvgIcon>
  )
})

export default Fullscreen
